import {Component, Input} from '@angular/core';


@Component({
    selector: 'tfl-panel-details-cell',
    template: `
        <div class="form-group row">
            <label class="control-label col-sm-6 col-xs-12">
                {{ label | translate : {company: ('BY_VENDOR.SPACE.TRADE'|translate)} }}
            </label>
            <div class="col-sm-6 col-xs-12 control-container">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class PanelDetailsCellComponent {
    @Input('label') label: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/panel-details/panel-details.cell.component.ts